import {
  Box,
  IconButton
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import {
  useEffect,
  useRef,
  useState
} from 'react';
import {
  useNavigate,
  useParams
} from 'react-router-dom';
import { theme } from 'theme';
import * as ds from './dataService';
import {
  PlanDocumentPane,
  PlanMetaDetailSection,
  PlanTaskPane
} from 'modules/components/layer35';
import { IFieldName } from 'modules/components/layer35/PlanMetaDetailSection/types';
import { PlanViewer } from 'modules/components/layer05';
import { useContainerDimensions } from 'modules/common/layer00';
import {
  RemovePlanModal,
  SavePlanModal,
  SavePlanVersionModal
} from 'modules/components/layer17';
import _ from 'lodash';

export type PlanDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanDetailSectionProps) => {

  const navigate = useNavigate();
  const params = useParams();
  const form = ds.useFormState(params.planId ?? '');
  const data = form.formState;

  const [
    isVisible,
    setIsVisible
  ] = useState(true);

  const [
    taskPaneVisible,
    setTaskPaneVisible
  ] = useState(false);
  const [
    documentPaneVisible,
    setDocumentPaneVisible
  ] = useState(false);

  const [
    isEditVisible,
    setIsEditVisible
  ] = useState(false);

  const [
    isDeleteVisible,
    setIsDeleteVisible
  ] = useState(false);


  const [
    isAddVisible,
    setIsAddVisible
  ] = useState(false);



  const fieldName2Value: Record<IFieldName, string> = {
    title: data.title,
    createdTimestamp: data.createdTimestamp.toFormat('DDDD'),
    fileSize: data?.versions.find((node) => node.id === data.selectedFileId)?.fileSize ?? '',
    fileType: data?.versions.find((node) => node.id === data.selectedFileId)?.fileType ?? '',
    updatedTimestamp: data.updatedTimestamp.toFormat('DDDD'),
    uploadedBy: data?.versions.find((node) => node.id === data.selectedFileId)?.uploadedBy ?? ''
  };

  const ref = useRef(null);

  const { width } = useContainerDimensions(ref);


  const [
    buffer,
    setBuffer
  ] = useState<ArrayBuffer | null>(null);


  useEffect(
    () => {
      (async () => {
        if (form.formState.selectedFileUrl === '') {
          return;
        }
        const file = await fetch(form.formState.selectedFileUrl);
        const tempBuffer = await file.arrayBuffer();

        setBuffer(() => tempBuffer);

      })();
      return () => {};
    },
    [
      data,
      form.formState.selectedFileUrl
    ]
  );


  return (
    <Box
      ref={ref}
    >
      {isAddVisible && (
        <SavePlanVersionModal.FC
          id={data.id}
          isVisible={isAddVisible}
          handleClose={() => setIsAddVisible(false)}
        />
      )}
      {isEditVisible && (
        <SavePlanModal.FC
          id={data.id}
          isVisible={isEditVisible}
          handleClose={() => setIsEditVisible(false)}
        />
      )}
      {isDeleteVisible && (
        <RemovePlanModal.FC
          id={data.id}
          isVisible={isDeleteVisible}
          handleClose={() => setIsDeleteVisible(() => false)}
        />
      )}
      {/* Wrapper for pdfViewer */}
      <Box
        height='100vh'
        overflow='auto'
        position='relative'
      >
        <PlanViewer.FC
          width={width}
          buffer={buffer}
          setBuffer={setBuffer}
          apiFileId={data?.versions.find((node) => node.id === data.selectedFileId)?.apiFileId ?? ''}
          annotations={data.annotations ?? []}
        />

        {/* ICON FOR BACK BUTTON */}
        <IconButton
          onClick={() => {
            navigate(-1);
          }}
          sx={{
            position: 'fixed',
            width: '2.25rem',
            height: '2.25rem',
            padding: '0.625rem',
            borderRadius: '.5rem',
            background: theme.palette.primary.light
          }}
        >
          <CustomIcon.medium.FC
            icon='CHEVRONLEFT'
            stroke={theme.palette.primary.light}
          />
        </IconButton>

        <PlanMetaDetailSection.FC
          title={fieldName2Value['title']}
          expanded={isVisible}
          setIsDeleteVisible={setIsDeleteVisible}
          showDetail={setIsVisible}
          editPlan={setIsEditVisible}
          fieldName2Value={fieldName2Value}
          addVersion={setIsAddVisible}
          form={form}
        />
        {!documentPaneVisible && (
          <PlanTaskPane.FC
            tasks={data.tasks.map((i) => ({
              ...i
            }))}
            expanded={taskPaneVisible}
            width={isVisible ? 'calc(100% - 400px)' : '100%'}
            showDetail={setTaskPaneVisible}
          />
        )}
        {!taskPaneVisible && (
          <PlanDocumentPane.FC
            documents={data.documents}
            expanded={documentPaneVisible}
            showDetail={setDocumentPaneVisible}
            width={isVisible ? 'calc(100% - 400px)' : '100%'}
          />
        )}
      </Box>
      {/*  */}
    </Box>
  );
};


